// extracted by css-extract-rspack-plugin
export default {"root":"ASG9b3QTIs024fU_","layout":"ztWAtED9ISEi0HvA","content":"vRoE53ORosAJStYm","image":"UWaol7vUBOku7vzw","title":"FAa7xQo8QuEeOD8M"};